var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickSpeechBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.626,18.344A10.016,10.016,0,0,0,12,1.829a10.023,10.023,0,1,0,3.479,19.418.332.332,0,0,1,.125-.021.256.256,0,0,1,.062.005l5.37.94-1.47-3.448A.375.375,0,0,1,19.626,18.344ZM17.605,8.617l-7.414,7.5a.521.521,0,0,1-.367.154h0a.519.519,0,0,1-.367-.152L6.4,13.06a.519.519,0,0,1,.733-.734l2.691,2.687,7.047-7.126a.519.519,0,1,1,.737.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSpeechBubble);
export default __webpack_public_path__ + "static/media/tick_speech_bubble.321a853b6f2eee1490141211a5d01774.svg";
export { ForwardRef as ReactComponent };